// src/Api/auth.js

import axios from 'axios';
import { BASE_API_URL, setWafeqCredentials  } from '../../src/Api/constants'; 
import { t } from '../utils/lang';
import Helper from '../utils/Helper';

class AuthService {
  constructor() {
    this.baseUrl = BASE_API_URL;
    this.refreshingPromise = null;
  }

  // دالة تسجيل الدخول الحالية - معدلة
  async performLogin(email, password) {
    const texts = t();
    try {
      const response = await axios.patch(`${this.baseUrl}client/login`, {
        Method: email,
        Password: password
      });

      const data = response.data;
      const userData = data?.data;
      
      if (!userData?.CustomerAccessToken) {
        throw new Error(texts.invalid_credentials || 'Invalid credentials');
      }
    if (userData?.Access) {
            setWafeqCredentials(userData.Access);
          }
      // حفظ بيانات المستخدم كاملة في localStorage
      const authData = {
        UserAccessToken: userData.CustomerAccessToken,
        UserRefreshToken: userData.CustomerRefreshToken, // إذا كان موجود
        user: userData
      };

      Helper.SetStorage("User", authData);
      localStorage.setItem("token", userData.CustomerAccessToken);

      return { success: true, user: userData, token: userData.CustomerAccessToken };

    } catch (err) {
      const statusCode = err?.response?.status;
      const apiMessage = err?.response?.data?.message;
      let errorMessage = apiMessage || err?.message || 'An unexpected error occurred.';

      if (statusCode === 401 || err.message.includes('Invalid credentials')) {
        errorMessage = texts.invalid_credentials || 'Invalid email or password.';
      } else {
        errorMessage = errorMessage || texts.generic_error || 'An error occurred.';
      }
      
      return { success: false, error: errorMessage };
    }
  }

  // دالة تجديد التوكن
  async refreshToken() {
    const user = Helper.GetStorage("User");
    
    if (!user?.UserRefreshToken) {
      await this.logout();
      return null;
    }

    try {
      const response = await axios.patch(`${this.baseUrl}auth/refresh`, {
        Token: user.UserRefreshToken
      }, {
        withCredentials: true
      });

      const newToken = response.data?.data?.UserAccessToken || 
                      response.data?.UserAccessToken || 
                      response.data?.token;

      if (newToken) {
        // تحديث بيانات المستخدم
        const updatedUser = {
          ...user,
          UserAccessToken: newToken
        };

        Helper.SetStorage("User", updatedUser);
        localStorage.setItem("token", newToken);

        return newToken;
      }
      
      return null;
    } catch (error) {
      console.error('Token refresh failed:', error);
      await this.logout();
      return null;
    }
  }

  // دالة تسجيل الخروج
  async logout() {
    try {
      const user = Helper.GetStorage("User");
      if (user?.UserRefreshToken) {
        await axios.post(`${this.baseUrl}auth/logout`, {
          Token: user.UserRefreshToken
        }, {
          withCredentials: true
        });
      }
    } catch (error) {
      console.error('Logout API call failed:', error);
    } finally {
      // تنظيف البيانات المحلية
      Helper.ClearStorage();
      localStorage.removeItem("token");

       setWafeqCredentials([]);
      
      // إعادة التوجيه لصفحة Login
      window.location.href = "/login";
    }
  }

  // التحقق من صلاحية التوكن
  isTokenValid() {
    const user = Helper.GetStorage("User");
    const token = user?.UserAccessToken;
    
    if (!token) return false;
    
    return !Helper.IsTokenExpired(token);
  }

  // الحصول على التوكن مع التجديد التلقائي إذا needed
  async getValidToken() {
    const user = Helper.GetStorage("User");
    const token = user?.UserAccessToken;
    
    if (!token) {
      await this.logout();
      return null;
    }

    // إذا التوكن صالح، رجعه
    if (!Helper.IsTokenExpired(token)) {
      return token;
    }

    // إذا التوكن منتهي، جدد
    if (!this.refreshingPromise) {
      this.refreshingPromise = this.refreshToken().finally(() => {
        this.refreshingPromise = null;
      });
    }

    await this.refreshingPromise;
    
    // رجع التوكن الجديد
    const updatedUser = Helper.GetStorage("User");
    return updatedUser?.UserAccessToken;
  }
}

// إنشاء instance واحد للاستخدام
const authService = new AuthService();

// Export الدوال الحالية للحفاظ على التوافقية
export const performLogin = (email, password) => authService.performLogin(email, password);
export const changePassword = async (oldPassword, newPassword) => {
  try {
    const token = await authService.getValidToken();
    const response = await axios.put(`${BASE_API_URL}client`, 
      {
        OldPassword: oldPassword,
        Password: newPassword 
      },
      {
        headers: {
          'X-T': `Bearer ${token}`
        }
      }
    );
    return { success: true, message: response.data.message || 'Password changed successfully!' };
  } catch (err) {
    const errorMessage = err?.response?.data?.message || 'Failed to change password.';
    return { success: false, error: errorMessage };
  }
};

// Export الـ service للاستخدام في الـ interceptor
export default authService;